export const feedPage = {
    'feed.page.feed.tab.posts': '帖子',
    'feed.page.feed.tab.toys': '玩具',
    'feed.page.toys.placeholder': '输入玩具名称',
    'feed.page.posts.placeholder': '输入帖子名称',
    'feed.page.feed.tab.digital': '数字',
    'feed.page.artists.placeholder': '输入艺术家名称',
    'feed.page.feed.tab.physical': '实体',
}
